<template>
  <b-modal
    id="save-filter-modal"
    ref="save-filter-modal"
    title="SAVE FILTER"
    title-tag="h4"
    title-class="text-uppercase font-weight-bolder"
    hide-footer
    centered
    size="sm"
    @hidden="resetModal"
  >
    <b-form
      ref="form"
      @submit.stop.prevent="handleSubmit"
    >
      <b-form-group
        label="Filter Name"
        label-for="filter-name-input"
        label-class="mb-1"
      >
        <b-form-input
          id="filter-name-input"
          v-model="filterName"
          :state="nameState"
          required
          placeholder="Enter Filter Name"
          class="mb-2"
        />
        <b-form-invalid-feedback :state="nameState">
          {{ nameFeedback }}
        </b-form-invalid-feedback>
        <div class="d-flex justify-content-end mt-2">
          <b-button
            variant="primary"
            class="px-3"
            @click="handleSubmit"
          >
            Save
          </b-button>
        </div>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BFormGroup, BFormInput, BForm, BButton, BFormInvalidFeedback,
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BFormInvalidFeedback,
  },
  data() {
    return {
      filterName: '',
      submitted: false,
    }
  },
  computed: {
    nameFeedback() {
      if (!this.filterName || this.filterName.trim().length === 0) {
        return 'Filter name is required'
      }
      if (this.filterName.length > 50) {
        return 'Filter name must be 50 characters or less'
      }
      return ''
    },
    nameState() {
      if (this.filterName.length > 50) {
        return false
      }
      if (this.submitted) {
        return !!(this.filterName && this.filterName.trim().length > 0)
      }
      return null
    },
  },
  methods: {
    resetModal() {
      this.filterName = ''
      this.submitted = false
    },
    handleSubmit() {
      this.submitted = true
      // Exit when the form isn't valid
      if (this.nameState === false) {
        return
      }
      // Push the name to callback
      this.$emit('save', this.filterName)
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('save-filter-modal')
      })
    },
    show() {
      this.$bvModal.show('save-filter-modal')
    },
  },
}
</script>

<style scoped>
::v-deep .modal-header {
  background-color: #f3f2f7;
  padding: 1rem;
}
::v-deep .modal-title {
  font-size: 1.1rem;
  color: #5e5873;
}
</style>
